import { useState } from "react";
import { ShieldCheck, AlertTriangle, Loader2 } from "lucide-react";
import { Modal } from "../lib/ui";
import { api, money } from "../lib/api";

export function BalanceCheckModal({ onClose, onOpenStatement }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");
  const run = async () => {
    setBusy(true); setError("");
    try { const { data } = await api.post("/customers/balance-check", {}, { timeout: 300000 }); setRes(data); }
    catch (e) { setError(e.response?.data?.detail || "Kontrol yapılamadı"); }
    finally { setBusy(false); }
  };
  return (
    <Modal title="Bakiye kontrolü" eyebrow="KONTROL" size="lg" onClose={onClose} testid="balance-check-modal"
           subtitle="Tüm carilerde liste bakiyesi ile ekstre bakiyesi karşılaştırılır">
      {!res && (
        <div className="modal-actions" style={{ justifyContent: "flex-start" }}>
          <button className="primary-button" disabled={busy} onClick={run} data-testid="balance-check-run">
            {busy ? <><Loader2 size={15} className="spin" /> Cariler taranıyor…</> : <><ShieldCheck size={15} /> Taramayı başlat</>}
          </button>
        </div>
      )}
      {error && <div className="form-error">{error}</div>}
      {res && (res.mismatches.length === 0 ? (
        <div className="merge-warn" style={{ background: "#f0fdf4", borderColor: "#bbf7d0", color: "#166534" }} data-testid="balance-check-ok">
          <ShieldCheck size={16} /> <span>{res.checked} cari tarandı, tüm bakiyeler ekstrelerle uyumlu.</span>
        </div>
      ) : (
        <>
          <div className="merge-warn danger" data-testid="balance-check-bad">
            <AlertTriangle size={16} /> <span>{res.checked} cari tarandı, <b>{res.mismatches.length}</b> caride uyuşmazlık var.</span>
          </div>
          <div className="dup-list">
            {res.mismatches.map((m) => (
              <div key={m.id} className="dup-row" data-testid={`balance-check-row-${m.id}`}>
                <div><strong>{m.name}</strong><small>Liste {money(m.list_balance)} · Ekstre {money(m.statement_balance)}</small></div>
                <div><small>Fark</small><strong className="negative">{money(m.diff)}</strong></div>
                <span />
                <button className="secondary-button" onClick={() => onOpenStatement?.({ id: m.id, name: m.name })}>Ekstre</button>
              </div>
            ))}
          </div>
        </>
      ))}
    </Modal>
  );
}
